export const DrawingsSumCard = ({sumDrawings, sumToDrawing}) => {
    // В7: остатък (налична площ за чертане) = Правно − Изчертано
    const available = (sumToDrawing || 0) - (sumDrawings || 0);

    // Сигнален фон само върху сивата част (header-а), не цялата карта:
    // 0 – 0.125 дка → бледо зелено (почти напълно изчертано);
    // под 0 → бледо червено (изчертано повече от правното).
    let headerBg;
    if (available < 0) {
        headerBg = "var(--app-danger-bg-soft)";
    } else if (available <= 0.125) {
        headerBg = "var(--app-success-bg)";
    }

    // Е17: налично < 0 → показва отрицателната стойност в ЧЕРВЕНО (преди беше „0").
    // Зеленото остава за 0 ≤ налично < 0.125 (прагът от В7 не се сменя).
    const isNegative = available < 0;
    const availableDisplay = isNegative
        ? available.toFixed(1)
        : (available < 0.125 ? "0" : available.toFixed(1));
    const availableColor = isNegative ? "var(--app-danger-fg)" : "var(--app-success-fg)";

    return (
        <div className="card" style={{width: "12rem", borderColor: "var(--app-gold)", borderWidth: "2px"}}>
            <div className="card-header d-flex justify-content-center"
                 style={{borderColor: "var(--app-gold)", borderWidth: "2px", ...(headerBg ? {backgroundColor: headerBg} : {})}}>
                <h4>Изчертано</h4>
            </div>
            <div className="d-flex justify-content-center align-items-stretch">
                <h5 className="card-title p-3 mb-0">{sumDrawings?.toFixed(2)}</h5>
                <span style={{borderLeft: "2px solid var(--app-gold)"}}></span>
                <h5 className="card-title p-3 mb-0" style={{color: availableColor}}
                    title="Налична площ за чертане">{availableDisplay}</h5>
            </div>
        </div>
    )
}
